import React, { useContext, useEffect } from "react";
import Bmi from "../ClinicalEvaluation/Bmi";
import NutritionalRisk from "../ClinicalEvaluation/NutritionalRisk";
import { Divider } from "antd";
import NutritionRiskFactors from "../ClinicalEvaluation/NutritionRiskFactors";
import CaloriesAndProtien from "./CaloriesAndProtien";
import TypeOfDiet from "./TypeOfDiet";
import OtherSpecifications from "./OtherSpecifications";
import PatientFamilyEducation from "./PatientFamilyEducation";
import { RiskAssessmentContext } from "../../Nutritionist/RiskAssessment/RiskAssessmentFormProvider";
import NutritionalScreeningRating from "../ClinicalEvaluation/NutritionalScreeningRating";

const NutritionistRiskAssessmentForm = ({ form, patientData }) => {
  const { formData } = useContext(RiskAssessmentContext);
  useEffect(() => {
    const fieldData = formData?.functional_diagnosis || {
      bmi: formData?.clinical_evaluation?.bmi,
      nutritional_risk_details:
        formData?.clinical_evaluation?.nutritional_risk_details,
      ...formData?.diet_advice,
    };
    form.setFieldsValue(fieldData);
  }, [formData]);
  return (
    <>
      <NutritionalScreeningRating form={form} risk={true} />
      <Divider />
      <Bmi
        context={RiskAssessmentContext}
        gender={patientData?.admission?.patient?.gender}
        form={form}
      />
      <Divider />
      <NutritionRiskFactors context={RiskAssessmentContext} />
      <Divider />
      <NutritionalRisk context={RiskAssessmentContext} form={form} />
      <Divider />
      <CaloriesAndProtien />
      <Divider />
      <TypeOfDiet context={RiskAssessmentContext} form={form} />
      <Divider />
      <OtherSpecifications context={RiskAssessmentContext} form={form} />
      <Divider />
      <PatientFamilyEducation form={form} />
    </>
  );
};

export default NutritionistRiskAssessmentForm;
